var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rf-divider",class:{
    'rf-divider--horizontal': _vm.orientation === 'horizontal',
    'rf-divider--vertical': _vm.orientation === 'vertical'
  },style:({
    ...{
      borderWidth:
        _vm.orientation === 'horizontal'
          ? `${_vm.thickness}px 0 0 0`
          : `0 ${_vm.thickness}px 0 0`
    },
    ..._vm._sx
  })})
}
var staticRenderFns = []

export { render, staticRenderFns }